import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToolbarRoutingModule } from './toolbar-routing.module';
import { TopToolbarComponent } from './top-toolbar/top-toolbar.component';

@NgModule({
  declarations: [ ],
  imports: [
    CommonModule,
    ToolbarRoutingModule
  ]
})
export class ToolbarModule { }
